import React, { useEffect, useState } from "react";
import styles from "./PartyFormModal.module.scss";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSave: (pending: number, received: number) => void;
  initialPending: number;
  initialReceived: number;
  originalPending: number;
  originalReceived: number;
};

const AmountSettingsModal = ({
  isOpen,
  onClose,
  onSave,
  initialPending,
  initialReceived,
  originalPending,
  originalReceived,
}: Props) => {
  const [pendingAmount, setPendingAmount] = useState<string>("");
  const [receivedAmount, setReceivedAmount] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setPendingAmount(initialPending.toFixed(2));
      setReceivedAmount(initialReceived.toFixed(2));
    }
  }, [isOpen, initialPending, initialReceived]);

  const handleReset = () => {
    setPendingAmount(originalPending.toFixed(2));
    setReceivedAmount(originalReceived.toFixed(2));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    await onSave(parseFloat(pendingAmount) || 0, parseFloat(receivedAmount) || 0);
    setIsLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className={styles.PartyFormModal}>
      <div className="relative h-[100vh] w-[100vw] overflow-y-scroll lg:overflow-auto top-0 lg:top-10 lg:mx-auto p-5 border lg:w-96 lg:h-fit shadow-lg lg:rounded-md bg-white">
        <div className="mt-3">
          <h3 className="text-2xl text-center font-bold leading-6 text-primary-1">
            અમાઉન્ટ સેટિંગ
          </h3>
          <div className="mt-2 py-3">
            <form onSubmit={handleSubmit}>
              <div className="grid gap-4">
                <div className="mt-4">
                  <label className="text-primary-1 font-bold">
                    બાકી પેમેન્ટ :
                  </label>
                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-14 w-full relative rounded">
                    <input
                      className="text-primary-1 focus:outline-none px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                      type="number"
                      step="0.01"
                      placeholder="બાકી પેમેન્ટ દાખલ કરો"
                      value={pendingAmount}
                      onChange={(e) => setPendingAmount(e.target.value)}
                      onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
                      required
                    />
                  </div>
                </div>

                <div>
                  <label className="text-primary-1 font-bold">
                    આવેલ પેમેન્ટ :
                  </label>
                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-14 w-full relative rounded">
                    <input
                      className="text-primary-1 focus:outline-none px-3 py-1 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                      type="number"
                      step="0.01"
                      placeholder="આવેલ પેમેન્ટ દાખલ કરો"
                      value={receivedAmount}
                      onChange={(e) => setReceivedAmount(e.target.value)}
                      onFocus={(e) =>
                        e.target.addEventListener(
                          "wheel",
                          function (e) {
                            e.preventDefault();
                          },
                          { passive: false }
                        )
                      }
                      required
                    />
                  </div>
                </div>

                <div className="mt-3 text-center">
                  <button
                    className="mx-auto shadow disabled:opacity-50 rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "રાહ જુઓ..." : "આગળ વધો"}
                  </button>
                </div>

                <div className="mt-1 text-center">
                  <button
                    className="mx-auto shadow disabled:opacity-50 rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                    type="button"
                    onClick={handleReset}
                    disabled={isLoading}
                  >
                    રિફ્રેશ કરો
                  </button>
                </div>

                <div className="mt-1 text-center">
                  <button
                    className="mx-auto shadow disabled:opacity-50 rounded-3xl text-3xl lg:text-xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                    type="button"
                    onClick={onClose}
                    disabled={isLoading}
                  >
                    બંધ કરો
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmountSettingsModal;
